export default __webpack_public_path__ + "static/media/logo.e56ccfb9.svg";